import React from 'react';
import './about.css'
import img from '../../img/me2.png'

const About = () => {
    var TxtType = function (el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function () {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
            this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
            this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
            delta = this.period;
            this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
            this.isDeleting = false;
            this.loopNum++;
            delta = 500;
        }

        setTimeout(function () {
            that.tick();
        }, delta);
    };

    window.onload = function () {
        var elements = document.getElementsByClassName('typewrite');
        for (var i = 0; i < elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
                new TxtType(elements[i], JSON.parse(toRotate), period);
            }
        }
        // INJECT CSS
        var css = document.createElement("style");
        css.type = "text/css";
        css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
        document.body.appendChild(css);
    };

   
    const time = () => {
        let p = 0;
        let pr = 0;
        let a = 0;

        const Project = setInterval(() => {
            p++
            if (p == 50) {
                clearInterval(Project)
            }
            document.getElementById('p').innerText = p + '+';
        }, 40);

        const Problem = setInterval(() => {
            pr++
            if (pr == 100) {
                clearInterval(Problem)
            }
            document.getElementById('pr').innerText = pr + '+';
        }, 20);

        const Award = setInterval(() => {
            a++
            if (a == 2) {
                clearInterval(Award)
            }
            document.getElementById('a').innerText = a;
        }, 1000);
    }
    time()
    


    // 


   
        window.onscroll = () => {
    
            const rotate = document.getElementById('rotate');
    
            if (window.scrollY > 800) {
                rotate.classList.add('rotate')
                console.log('scroll')
            }
        }
    return (
        <div id='about'>
            <div className='about lg:p-10 p-5 bg-about'>
                <span className='flex justify-start items-center'>
                    <p className='text-white font-bold'> About</p>
                    <div className='h-[2px] ml-4 lg:w-96  w-2/4 bg-green-600'></div>
                </span>
                <h1 id='text' className='text-2xl font-bold text-white mt-5' data-aos="fade-right">LEARN MORE ABOUT ME</h1>

                {/* body  */}
                <div className='lg:flex mt-5 justify-between gap-10'>
                    <img className='bg-black lg:w-2/4' src={img} alt="" />
                    {/* <img className='lg:w-2/4' src="https://images.unsplash.com/photo-1450133064473-71024230f91b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Z3V5JTIwaW4lMjBibGFjayUyMGJhY2tncm91bmR8ZW58MHx8MHx8&w=1000&q=80" alt="" /> */}
                    <div className='lg:w-2/4'>
                        <h1 className='text-2xl font-bold text-green-500' data-aos="flip-right">Full stack Web Developer</h1>
                        <p className='text-white font-semibold mt-3 text-justify' data-aos="flip-right">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        <div>
                            <p className='font-bold text-white mt-5' data-aos="fade-right">
                                <i class="fa-solid fa-pen-nib text-green-500 mr-4"></i>
                                Birthday : 19 Dec 2004
                            </p>
                            <p className='font-bold text-white mt-2' data-aos="fade-right">
                                <i class="fa-solid fa-pen-nib text-green-500 mr-4"></i>
                                Age : 18
                            </p>
                            <p className='font-bold text-white mt-2' data-aos="fade-right">
                                <i class="fa-solid fa-pen-nib text-green-500 mr-4"></i>
                                City : Dinajpur, Bangladesh
                            </p>
                            <p className='font-bold text-white mt-2' data-aos="fade-right">
                                <i class="fa-solid fa-pen-nib text-green-500 mr-4"></i>
                                Phone : 01867585183
                            </p>
                            <p className='font-bold text-white mt-2' data-aos="fade-right">
                                <i class="fa-solid fa-pen-nib text-green-500 mr-4"></i>
                                Email : fl.shamim69@gmail.com
                            </p>
                            <p className='font-bold text-white mt-2' data-aos="fade-right">
                                <i class="fa-solid fa-pen-nib text-green-500 mr-4"></i>
                                Freelance : Available
                            </p>
                            <button data-aos="fade-left" className='border-2 border-green-500 text-white font-bold px-3 py-2 lg:mt-14 mt-10 hover:bg-green-500 duration-500 rounded'>Download Resume</button>
                        </div>
                    </div>
                </div>
                {/* what i do  */}
                <section id='rotate'  className=' lg:flex gap-5 justify-between mt-20'>
                    <div className=' bg-card mt-10 text-white font-bold text-center p-10 w-full' data-aos="slide-up">
                        <div className='bg_icon rounded-full h-16 w-16 p-5 mt-[-4.5rem] mx-auto flex justify-center items-center'><i class="fa-sharp fa-solid fa-code font-bold  text-green-500 text-4xl"></i></div>
                        <h1 id='p' className='text-4xl mb-5 mt-5'></h1>
                        <p>Complete Project </p>
                    </div>
                    <div className=' bg-card mt-10 text-white font-bold text-center p-10 w-full' data-aos="fade-left">
                        <div className='bg_icon rounded-full h-16 w-16 p-5 mt-[-4.5rem] mx-auto flex justify-center items-center  text-green-500 text-4xl'><i class="fa-sharp fa-solid fa-calculator"></i></div>
                        <h1 className='text-4xl mb-5 mt-5' id='pr'>100 +</h1>
                        <p>Problem Solve</p>
                    </div>
                    <div className=' bg-card mt-10 text-white font-bold text-center p-10 w-full ' data-aos="slide-up">
                        <div className='bg_icon rounded-full h-16 w-16 p-5 mt-[-4.5rem] mx-auto flex justify-center items-center'><i class="fa-sharp fa-solid fa-award  text-green-500 text-4xl"></i></div>
                        <h1 className='text-4xl mb-5 mt-5' id='a'>0</h1>
                        <p>Award</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default About;